
import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import HomePage from "../pages/home/home-page";
import SelectExam from "../pages/select-exam/page";
import ExamInstructions from "../pages/exam-instructions/page";
import Exam from "../pages/exam/page";
import ExamResult from "../pages/exam-result/page";
import Results from "../pages/results/page";
import SearchQualifications from "../pages/search-qualifications/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import ShikakuManagement from "../pages/admin/shikaku-management/page";
import BookStructurePage from "../pages/admin/book-structure/page";
import AnswerSheetManagement from "../pages/admin/answer-sheet-management/page";
import OnlineTestSummaryPage from "../pages/admin/onlinetest/page";
import AnswerSheetDetailPage from "../pages/admin/answer-sheet-detail/page";
import UserManagement from "../pages/admin/user-management/page";
import UserDetail from "../pages/admin/user-management/UserDetail";
import QuestionsManagement from "../pages/admin/questions-management/page";
import ExamSetManagementPage from "../pages/admin/exam-set-management/page";
import ShikakuListPage from "../pages/admin/questions-management/shikaku-list-page";
import QuizzesManagement from "../pages/admin/quizzes-management/page";
import OrderManagement from "../pages/admin/order-management/page";
import OrderDetail from "../pages/admin/order-detail/OrderDetail";
import OrderTaskPrint from "../pages/admin/order-detail/OrderTaskPrint";
import OrderExamPrint from "../pages/admin/order-detail/OrderExamPrint";
import OrderShippingPrint from "../pages/admin/order-detail/OrderShippingPrint";
import InformationManagement from "../pages/admin/information-management/page";
import InventoryManagementPage from "../pages/admin/inventory-management/page";
import InventoryRuleSetsPage from "../pages/admin/inventory-rule-sets/page";
import LearningRestrictionsPage from "../pages/admin/learning-restrictions/page";
import AdminSettingsPage from "../pages/admin/settings/page";
import MailAccountSettingsPage from "../pages/admin/settings/mail-accounts/page";
import ExamResultDetail from "../pages/exam-result-detail/page";
import UserProfile from "../pages/user-profile/page";
import ManualPage from "../pages/manual/page";
import InformationDetail from "../pages/information-detail/page";
import InformationList from "../pages/information-list/page";
import LearningPage from "../pages/learning/page";
import QuizPage from "../pages/quiz/page";
import QuizPlayPage from "../pages/quiz/play/page";
import QuizMenuPage from "../pages/quiz/menu/page";
import QuizHistoryPage from "../pages/quiz/history/page";
import MockExamPage from "../pages/mockexam/page";
import MockExamPlayPage from "../pages/mockexam/play/page";
import MockExamHistoryPage from "../pages/mockexam/history/page";
import ViewTextPage from "../pages/viewtext/page";
import MailListPage from "../pages/mail/MailListPage";
import MailDetailPage from "../pages/mail/MailDetailPage";
import MailMessageDetailPage from "../pages/mail/MailMessageDetailPage";
import MailComposePage from "../pages/mail/MailComposePage";
import MailTemplatePage from "../pages/mail/MailTemplatePage";
import MailRulesPage from "../pages/mail/MailRulesPage";
import DocumentTemplatePage from "../pages/admin/templates/DocumentTemplatePage";
import SampleMaterialsPage from "../pages/admin/sample-materials/page";
import MailingListPage from "../pages/admin/marketing/mailing-list/page";
import OnlineGuidePage from "../pages/admin/marketing/online-guide/page";
import WishlistPage from "../pages/admin/marketing/wishlist/page";
import PaymentManagementPage from "../pages/admin/paymentmg/page";
import BankDataHistoryPage from "../pages/admin/paymentmg/bankdata-page";
import AnalysisPage from "../pages/admin/analysis/page";
import DailyDataPage from "../pages/admin/analysis/dailydata-page";
import CompetitiveAnalysisPage from "../pages/admin/analysis/competitive-analysis-page";
import CompetitiveMappingPage from "../pages/admin/analysis/competitive-mapping-page";
import CompetitiveScrapePage from "../pages/admin/analysis/competitive-scrape-page";
import ProtectedRoute from "../components/ProtectedRoute";
import AdminLayout from "../components/layouts/AdminLayout";
import LearningRestrictionGuard from "../components/LearningRestrictionGuard";

const adminRoutes: RouteObject[] = [
  {
    path: "/admin",
    element: (
      <ProtectedRoute requireAdmin>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/admin/dashboard" replace />,
      },
      {
        path: "dashboard",
        element: <AdminDashboard />,
      },
      {
        path: "shikaku",
        element: <ShikakuManagement />,
      },
      {
        path: "book-structure",
        element: <BookStructurePage />,
      },
      {
        path: "onlinetest",
        element: <OnlineTestSummaryPage />,
      },
      {
        path: "answers",
        element: <AnswerSheetManagement />,
      },
      {
        path: "answers/:id",
        element: <AnswerSheetDetailPage />,
      },
      {
        path: "users",
        element: <UserManagement />,
      },
      {
        path: "users/:id",
        element: <UserDetail />,
      },
      {
        path: "questions",
        element: <QuestionsManagement />,
      },
      {
        path: "exam-sets",
        element: <ExamSetManagementPage />,
      },
      {
        path: "questions/shikaku-list",
        element: <ShikakuListPage />,
      },
      {
        path: "quiz",
        element: <QuizzesManagement />,
      },
      {
        path: "orders",
        element: <OrderManagement />,
      },
      {
        path: "orders/:id",
        element: <OrderDetail />,
      },
      {
        path: "orders/:id/task",
        element: <OrderTaskPrint />,
      },
      {
        path: "orders/:id/exam",
        element: <OrderExamPrint />,
      },
      {
        path: "orders/:id/shipping",
        element: <OrderShippingPrint />,
      },
      {
        path: "information",
        element: <InformationManagement />,
      },
      {
        path: "learning-restrictions",
        element: <LearningRestrictionsPage />,
      },
      {
        path: "settings",
        element: <AdminSettingsPage />,
      },
      {
        path: "settings/mail-accounts",
        element: <MailAccountSettingsPage />,
      },
      {
        path: "inventory",
        element: <InventoryManagementPage />,
      },
      {
        path: "inventory-rule-sets",
        element: <InventoryRuleSetsPage />,
      },
      {
        path: "sample-materials",
        element: <SampleMaterialsPage />,
      },
      {
        path: "marketing/mailing-list",
        element: <MailingListPage />,
      },
      {
        path: "marketing/online-guide",
        element: <OnlineGuidePage />,
      },
      {
        path: "marketing/wishlist",
        element: <WishlistPage />,
      },
      {
        path: "paymentmg",
        element: <PaymentManagementPage />,
      },
      {
        path: "paymentmg/bankdata",
        element: <BankDataHistoryPage />,
      },
      {
        path: "analysis",
        element: <AnalysisPage />,
      },
      {
        path: "analysis/dailydata",
        element: <DailyDataPage />,
      },
      {
        path: "analysis/competitive",
        element: <CompetitiveAnalysisPage />,
      },
      {
        path: "analysis/competitive-mapping",
        element: <CompetitiveMappingPage />,
      },
      {
        path: "analysis/competitive-scrape",
        element: <CompetitiveScrapePage />,
      },
      {
        path: "mail",
        element: <MailListPage />,
      },
      {
        path: "mail/new",
        element: <MailComposePage />,
      },
      {
        path: "mail/templates",
        element: <MailTemplatePage />,
      },
      {
        path: "templates/mail",
        element: <MailTemplatePage />,
      },
      {
        path: "templates/documents",
        element: <DocumentTemplatePage />,
      },
      {
        path: "mail/messages/:messageId",
        element: <MailMessageDetailPage />,
      },
      {
        path: "mail/rules",
        element: <MailRulesPage />,
      },
    ],
  },
];

const sharedRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/home",
    element: (
      <ProtectedRoute>
        <HomePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/select-exam",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="examEnabled">
          <SelectExam />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/exam-instructions",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="examEnabled">
          <ExamInstructions />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/exam",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="examEnabled">
          <Exam />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/exam-result",
    element: (
      <ProtectedRoute>
        <ExamResult />
      </ProtectedRoute>
    ),
  },
  {
    path: "/results",
    element: (
      <ProtectedRoute>
        <Results />
      </ProtectedRoute>
    ),
  },
  {
    path: "/exam-result/:id",
    element: (
      <ProtectedRoute>
        <ExamResultDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: "/search-qualifications",
    element: (
      <ProtectedRoute>
        <SearchQualifications />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <UserProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/quiz/play",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="quizEnabled">
          <QuizPlayPage />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/quiz/menu",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="quizEnabled">
          <QuizMenuPage />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/quiz/history",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="quizEnabled">
          <QuizHistoryPage />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/manual",
    element: (
      <ProtectedRoute>
        <ManualPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/learning",
    element: (
      <ProtectedRoute>
        <LearningPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/quiz",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="quizEnabled">
          <QuizPage />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mockexam",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="mockExamEnabled">
          <MockExamPage />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mockexam/play",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="mockExamEnabled">
          <MockExamPlayPage />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mockexam/history",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="mockExamEnabled">
          <MockExamHistoryPage />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/viewtext",
    element: (
      <ProtectedRoute>
        <LearningRestrictionGuard restrictionKey="viewTextEnabled">
          <ViewTextPage />
        </LearningRestrictionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/mail",
    element: (
      <ProtectedRoute>
        <MailListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/mail/new",
    element: (
      <ProtectedRoute>
        <MailComposePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/mail/templates",
    element: (
      <ProtectedRoute>
        <MailTemplatePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/mail/messages/:messageId",
    element: (
      <ProtectedRoute>
        <MailMessageDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/information",
    element: (
      <ProtectedRoute>
        <InformationList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/information/:id",
    element: (
      <ProtectedRoute>
        <InformationDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export const ADMIN_HOSTNAME = "admin.lear-caree.jp";
export const ADMIN_ALLOWED_HOSTNAMES = [ADMIN_HOSTNAME, "localhost", "127.0.0.1"];

export function createRoutes(isAdminHost: boolean): RouteObject[] {
  return isAdminHost ? [...adminRoutes, ...sharedRoutes] : sharedRoutes;
}
